var map = {
	"./BOOST.svg": 2417,
	"./GRAB.svg": 2418,
	"./MBB.svg": 2419,
	"./TNG.svg": 2420,
	"./direpay.svg": 2421,
	"./doitnow.svg": 2422,
	"./duitnow.svg": 2423,
	"./fpay.svg": 2424,
	"./fpay2.svg": 2425,
	"./fpx.svg": 2426,
	"./online_banking.svg": 2427,
	"./rapidpays.svg": 2428,
	"./secret_pay.svg": 2429,
	"./secret_pay_offline.svg": 2430,
	"./secret_pay_pro.svg": 2431,
	"./secret_pay_pro_b.svg": 2432
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 213;